export default {
  capture: eventName => {
    if (typeof posthog !== 'undefined') {
      posthog.capture(eventName);
    }
  }
}